<template>
    <div>
        <div class="bee_star_base_layout">
            <div class="flex flex-col" style="margin-right: 12px;">
                <div class="bee_star_title">Bee Score</div>
                <div class="bee_star_score_tdb" v-if="score == 0">tbd</div>
                <div v-else class="bee_star_score">{{ score }}</div>

                <div class="flex flex-row mt-2">
                    <star-rating :rating="score" :read-only="true" :increment="0.01" :show-rating="false"
                        :star-size="20" />

                </div>

            </div>

            <div class="bee_star_score_info_base">
                <div class="bee_star_score_info_layout">
                    <img src="../assets/icon_start_5.png" class="bee_star_plus_logo">

                    <div class="bee_star_progress_base">

                        <div class="bee_star_progress_bar" :style="`width: ${score_1}%;`"> </div>

                    </div>

                    <div class="bee_star_score_info_txt"> {{ score_1 }}%

                    </div>

                </div>

                <div class="bee_star_score_info_layout">
                    <img src="../assets/icon_start_4.png" class="bee_star_plus_logo">

                    <div class="bee_star_progress_base">

                        <div class="bee_star_progress_bar" :style="`width: ${score_2}%;`"> </div>

                    </div>

                    <div class="bee_star_score_info_txt"> {{ score_2 }}%

                    </div>

                </div>

                <div class="bee_star_score_info_layout">
                    <img src="../assets/icon_start_3.png" class="bee_star_plus_logo">

                    <div class="bee_star_progress_base">

                        <div class="bee_star_progress_bar" :style="`width: ${score_3}%;`"> </div>

                    </div>

                    <div class="bee_star_score_info_txt"> {{ score_3 }}%

                    </div>

                </div>
                <div class="bee_star_score_info_layout">
                    <img src="../assets/icon_start_2.png" class="bee_star_plus_logo">

                    <div class="bee_star_progress_base">

                        <div class="bee_star_progress_bar" :style="`width: ${score_4}%;`"> </div>

                    </div>

                    <div class="bee_star_score_info_txt"> {{ score_4 }}%

                    </div>

                </div>

                <div class="bee_star_score_info_layout">
                    <img src="../assets/icon_start_1.png" class="bee_star_plus_logo">

                    <div class="bee_star_progress_base">

                        <div class="bee_star_progress_bar" :style="`width: ${score_5}%;`"> </div>

                    </div>

                    <div class="bee_star_score_info_txt"> {{ score_5 }}%

                    </div>

                </div>


            </div>

        </div>

        <div class="line"></div>
    </div>
</template>
<script>
import { base_url, getPostId } from '../util/mock.js';
import StarRating from 'vue-star-rating'
import { addEmit, resultEmitEvent } from "../util/event";
export default {
    name: 'topStarView',
    props: {
        title: String,
        msg: String,
    },
    components: { StarRating },
    data() {
        return {
            score: "0",
            show: false,
            score_1: "0",
            score_2: "0",
            score_3: "0",
            score_4: "0",
            score_5: "0",
        }
    },

    watch: {

    },

    methods: {
        async getScoreData() {
            let post_id = getPostId();
            console.log(post_id);
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_rest_post_get_score_callback',
                    _wpnonce: "wp_nonce",
                    post_id: post_id,
                }),
            };

            const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();
            let scoreData = data.data.data;
            console.log(scoreData)
            this.score = scoreData.score;
            this.score_1 = (scoreData.p5 * 100).toFixed(0);
            this.score_2 = (scoreData.p4 * 100).toFixed(0);
            this.score_3 = (scoreData.p3 * 100).toFixed(0);
            this.score_4 = (scoreData.p2 * 100).toFixed(0);
            this.score_5 = (scoreData.p1 * 100).toFixed(0);

            let userScore = scoreData.uScore;
            addEmit("scoreUserChange", userScore);
        }
    },

    mounted() {
        this.getScoreData();

    },


}

</script>

<style scoped>
.bee_star_base_layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bee_star_title {
    font-size: 16px;
    color: #999999;
    font-weight: 400;
}

.bee_star_score {
    font-size: 50px;
    color: #000;
    font-weight: 700;
    line-height: 62px;
}

.bee_star_score_tdb {
    font-size: 40px;
    color: #999;
    font-weight: 700;
    line-height: 62px;
}

.bee_star_logo {
    width: 20px;
    height: 20;
}

.bee_star_progress_base {
    background-color: #EFEDEA;
    border-radius: 4px;
    height: 6px;
    display: inline;
    flex: 1;
}

.bee_star_plus_logo {
    width: 100px;
    height: 20;
}

.bee_star_score_info_layout {
    display: flex;
    flex: 1;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
}

.bee_star_score_info_base {
    display: inline;
    flex: 1;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
}

.bee_star_score_info_txt {
    font-size: 16px;
    color: #333;
    font-weight: 400;
    width: 50px;
    text-align: right;
}

.bee_star_progress_bar {
    background-color: #FFC04D;
    border-radius: 4px;
    height: 6px;
}

.line {
    display: flex;
    background-color: #EFEFEF;
    height: 1px;
    margin-top: 16px;
    margin-bottom: 16px;
}
</style>